import React, { Component } from "react";

import { connect } from "react-redux";

import state from "../state";
import ColorSetter from "./NewColorPicker";
import ImageUploader from "./ImageUploader";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Select, TextField } from "./FormElements";

import { l } from "../functions";
import { setShowBlockSettings } from "../core/redux/actions";
import Icons from "./Icons";
import { fontList } from "../consts/fonts";
import HoverSpacer from "./HoverSpacer";

function mapStateToProps(state) {
  return {
    elementToEdit: state.rootReducer.elementToEdit || null,
    elementOptions: state.rootReducer.elementOptions || [],
    currentDevice: state.rootReducer.currentDevice || "xl",
    fetchedLangs: state.rootReducer.fetchedLangs || [],
    currentLang: state.rootReducer.currentLang || 1,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    editElement: (element) => dispatch({ type: "EDIT_ELEMENT", element }),
    setShowBlockSettings: () =>
      dispatch({ type: "SHOW_BLOCK_SETTINGS", showBlockSettings: true }),
  };
}

class WisywigCommandCenter extends Component {
  constructor(props) {
    super(props);

    this.defaultSettings = {
      background: {
        backgroundImage: null,
        backgroundColor: null,
        backgroundSize: "cover",
        backgroundRepeat: "repeat",
        backgroundPosition: "center center",
      },
      border: {
        borderLeft: null,
        borderTop: null,
        borderRight: null,
        borderBottom: null,
      },
      spacing: null,
      text: null,
      alignment: null,
    };

    this.defaultState = {
      current_style: null,
      currentTab: 1,
      slideDialog: null,
      selectedFields: {},
      selectedFieldsValue: {},
      globalSettings: {},
      url: "",
    };

    this.state = {
      ...this.defaultState,
      ...{
        listDatas: null,
        styles: [],
        datas: {},
        settings: this.defaultSettings,
      },
      popup: null,
    };
    this.fontList = fontList;
    this.weightLabel = {
      200: "Extra light",
      300: "Light",
      400: "Regular",
      500: "Medium",
      600: "Semi bold",
      700: "Bold",
      800: "Extra bold",
      900: "Black",
    };
  }

  componentDidMount() {
    const elementToEdit = this.props.elementToEdit;
    const currentDevice = this.props.currentDevice;

    if (elementToEdit !== null && currentDevice !== null) {
      let datasIndex = "datas";
      let settingsIndex = "settings";

      const { id, dropzoneID, parentID } = elementToEdit;
      const { payload } = state.getFullElement(id, dropzoneID, parentID) || {};

      if (currentDevice !== "xl") {
        datasIndex = datasIndex + "-" + currentDevice;
        settingsIndex = settingsIndex + "-" + currentDevice;
      }

      let currentSettings =
        elementToEdit ||
        elementToEdit?.payload[settingsIndex] ||
        elementToEdit?.payload?.settings;
      if (payload) currentSettings = payload[settingsIndex] || payload.settings;

      let currentDatas = elementToEdit || elementToEdit.payload.datas || {};
      if (payload) currentDatas = payload?.datas || {};

      const oldDatas = this.props.datas;

      this.setState({
        settings: currentSettings || this.defaultSettings,
        datas: currentDatas !== oldDatas ? currentDatas : [],
        url:
          currentDatas["url_" + this.props.currentLang] ||
          currentDatas.url ||
          "",
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      (prevState.settings !== this.state.settings &&
        this.state.settings !== null) ||
      (prevState.datas !== this.state.datas && this.state.datas !== null)
    ) {
      const { elementToEdit } = this.props;
      if (elementToEdit !== null) {
        const { id, dropzoneID, parentID } = elementToEdit;
        const { payload } =
          state.getFullElement(id, dropzoneID, parentID) || {};

        let settingsIndex = "settings";

        if (this.props.currentDevice !== "xl")
          settingsIndex = settingsIndex + "-" + this.props.currentDevice;

        const newPlayload = {
          ...payload,
          [settingsIndex]: this.state.settings,
          datas: this.state.datas,
        };

        state.updateElement(id, dropzoneID, parentID, {
          payload: newPlayload,
        });
      }
    }
  }

  componentWillReceiveProps({ elementToEdit, currentDevice }) {
    if (elementToEdit === null) {
      this.setState(this.defaultState);
    } else {
      const oldElement = this.props.elementToEdit;

      if (
        oldElement === null ||
        elementToEdit.id !== oldElement.id ||
        this.props.currentDevice !== currentDevice
      ) {
        let datasIndex = "datas";
        let settingsIndex = "settings";

        const { id, dropzoneID, parentID } = elementToEdit;
        const { payload } =
          state.getFullElement(id, dropzoneID, parentID) || {};

        if (currentDevice !== "xl") {
          datasIndex = datasIndex + "-" + currentDevice;
          settingsIndex = settingsIndex + "-" + currentDevice;
        }

        let currentSettings =
          elementToEdit ||
          elementToEdit?.payload[settingsIndex] ||
          elementToEdit?.payload?.settings;
        if (payload)
          currentSettings = payload[settingsIndex] || payload.settings;

        let currentDatas = elementToEdit || elementToEdit.payload.datas || {};
        if (payload) currentDatas = payload?.datas || {};

        const oldDatas = this.props.datas;

        this.setState({
          settings: currentSettings || this.defaultSettings,
          datas: currentDatas !== oldDatas ? currentDatas : [],
          url:
            currentDatas["url_" + this.props.currentLang] ||
            currentDatas.url ||
            "",
        });
      }
    }
  }

  _changedDatasOne = (index, value = 0, cb = () => { }) => {
    this.setState(
      {
        ...this.state,
        datas: {
          ...this.state.datas,
          [index]: value,
        },
      },
      () => {
        cb();
      }
    );
  };

  _changedSettingsOne = (index, value, cb = () => { }) => {
    this.setState(
      {
        ...this.state,
        settings: {
          ...this.state.settings,
          [index]: value,
        },
      },
      () => {
        cb();
      }
    );
  };

  _fontsWeightOptions = (fontId, fontFamily) => {
    let object = [
      {
        label: "Extra Thin",
        value: 100,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 100 },
        },
      },
      {
        label: "Thin",
        value: 200,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 200 },
        },
      },
      {
        label: "regular",
        value: 300,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 300 },
        },
      },
      {
        label: "Medium",
        value: 400,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 400 },
        },
      },
      {
        label: "Semi Bold",
        value: 500,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 500 },
        },
      },
      {
        label: "Bold",
        value: 600,
        props: {
          style: { fontFamily: fontFamily, fontWeight: 600 },
        },
      },
    ];
    return object;
  };

  _changedSettingsTwo = (indexOne, indexTwo, value = 0, cb = () => { }) => {
    let objectValue;
    if (Array.isArray(indexTwo)) {
      let newvalue = {};

      indexTwo.forEach((index) => {
        newvalue[index] = value;
      });

      objectValue = { ...this.state.settings[indexOne], ...newvalue };
    } else {
      objectValue = {
        ...this.state.settings[indexOne],
        [indexTwo]: value,
      };
    }

    this._changedSettingsOne(indexOne, objectValue, () => {
      cb();
    });
  };

  _addTab = (elements = [], index, label, cb = () => { }) => {
    const Id = Math.floor(Math.random() * 999999 + 9999);
    const content = {
      id: Id.toString(),
      data: {
        title_1: label + " " + parseInt(elements.length + 1),
      },
      rank: elements.length,
    };
    let newElements = [];

    if (elements) newElements = elements.concat([content]);
    else newElements = [content];

    cb(newElements);
  };

  render() {
    const { elementToEdit: element } = this.props;
    const { settings, datas } = this.state;

    const { activeColor, barColor, counterColor } = datas || {
      timerCountDown: 60,
      activeColor: "#FFF",
      barColor: "#FFF",
      counterColor: "#FFF",
    };

    let { timerBgColor, timerColor } = datas || {}; // Products Countdown Timer Settings
    if (settings?.timerBgColor) {
      timerBgColor = settings?.timerBgColor;
    }
    if (settings?.timerColor) {
      timerColor = settings?.timerColor;
    }

    const { viewersTextColor, viewersBgColor } = datas || {
      viewersNumber: [0, 2000],
    }; // Products viewers Settings

    const {
      background: backgroundSettings,
      spacing: spacingSettings,
      text: textSettings,
      alignment,
    } = settings || {}; // CSS Settings

    const { headingText = "" } = datas || {};

    const imageUrl =
      datas["imageUrl_" + this.props.currentLang] || datas.imageUrl || ""; // Image Settings

    if (element) {
      let availableSettings = {};

      if (
        element.elementId &&
        this.props.elementOptions[element.elementId] &&
        this.props.elementOptions[element.elementId].settings
      ) {
        availableSettings =
          this.props.elementOptions[element.elementId].settings;
      } else {
        availableSettings = this.props.elementToEdit?.options?.settings || {};
      }

      return (
        <>
          {availableSettings.spacing && (
            <li className="prelative">
              <HoverSpacer
                spacingSettings={spacingSettings}
                onChange={this._changedSettingsTwo}
                hoverBar
                onClickIcon={() => {
                  if (this.state.popup === "spacing") {
                    this.setState({ popup: null });
                  } else {
                    this.setState({ popup: "spacing" });
                  }
                }}
                open={this.state.popup === "spacing"}
              />
            </li>
          )}
          {element.type === "tabs" && (
            <li>
              <Icons
                icon="plus"
                onClick={() => {
                  this._addTab(
                    this.state.datas.tabs,
                    "tabs",
                    "Tab",
                    (elements) => {
                      this._changedDatasOne("tabs", elements);
                    }
                  );
                }}
              />
            </li>
          )}
          {element.type === "collapse_heading" && (
            <li className="prelative">
              <li
                className="quickbar"
                style={{
                  color: "white",
                  fontFamily: "Calistoga, cursive",
                  fontWeight: "300",
                }}
                onClick={() => {
                  if (this.state.popup !== "textEdit")
                    this.setState({
                      popup: "textEdit",
                    });
                  else this.setState({ popup: null });
                }}
              >
                <span style={{ marginTop: 4 }}>T</span>
              </li>
              {this.state.popup === "textEdit" && (
                <div className="section quickbartools">
                  <ul style={{ width: 240 }}>
                    <TextField
                      placeholder={"Heading Text"}
                      value={headingText || ""}
                      onChange={(value) => {
                        this._changedDatasOne("headingText", value);
                      }}
                      dark
                    />
                  </ul>
                </div>
              )}
            </li>
          )}
          {element?.name == "Image" && (
            <li>
              <ImageUploader
                quickbar
                buttonText=""
                withIcon={true}
                onChange={(url) => {
                  this._changedDatasOne(
                    "imageUrl_" + this.props.currentLang,
                    url
                  );
                }}
                imgExtension={[
                  ".jpg",
                  ".gif",
                  ".png",
                  ".gif",
                  ".jpeg",
                  ".webp",
                ]}
                maxFileSize={5242880}
                withPreview={true}
                singleImage={true}
                defaultImages={imageUrl || ""}
              />
            </li>
          )}
          {element.name == "Button" && (
            <>
              <li className="prelative">
                <li
                  className={`quickbar ${this.state.popup === "buttonSize" ? "selected" : ""
                    }`}
                  onClick={() => {
                    if (this.state.popup !== "buttonSize")
                      this.setState({
                        popup: "buttonSize",
                      });
                    else this.setState({ popup: null });
                  }}
                >
                  <span style={{ pointerEvents: "none" }}>S</span>
                </li>

                {this.state.popup === "buttonSize" && (
                  <div className="section quickbartools">
                    <ul className="inline-options dark grow">
                      <li
                        className={`${spacingSettings &&
                          spacingSettings.paddingTop == 5 &&
                          spacingSettings.paddingBottom == 5 &&
                          spacingSettings.paddingLeft == 10 &&
                          spacingSettings.paddingRight == 10
                          ? "selected"
                          : ""
                          }`}
                        onClick={() => {
                          this._changedSettingsTwo(
                            "spacing",
                            ["paddingRight", "paddingLeft"],
                            10,
                            () => {
                              this._changedSettingsTwo(
                                "spacing",
                                ["paddingTop", "paddingBottom"],
                                5
                              );
                            }
                          );
                        }}
                      >
                        <span style={{ pointerEvents: "none" }}>S</span>
                      </li>
                      <li
                        className={`${spacingSettings &&
                          spacingSettings.paddingTop == 10 &&
                          spacingSettings.paddingBottom == 10 &&
                          spacingSettings.paddingLeft == 20 &&
                          spacingSettings.paddingRight == 20
                          ? "selected"
                          : ""
                          }`}
                        onClick={() => {
                          this._changedSettingsTwo(
                            "spacing",
                            ["paddingRight", "paddingLeft"],
                            20,
                            () => {
                              this._changedSettingsTwo(
                                "spacing",
                                ["paddingTop", "paddingBottom"],
                                10
                              );
                            }
                          );
                        }}
                      >
                        <span style={{ pointerEvents: "none" }}>M</span>
                      </li>
                      <li
                        className={`${spacingSettings &&
                          spacingSettings.paddingTop == 15 &&
                          spacingSettings.paddingBottom == 15 &&
                          spacingSettings.paddingLeft == 30 &&
                          spacingSettings.paddingRight == 30
                          ? "selected"
                          : ""
                          }`}
                        onClick={() => {
                          this._changedSettingsTwo(
                            "spacing",
                            ["paddingRight", "paddingLeft"],
                            30,
                            () => {
                              this._changedSettingsTwo(
                                "spacing",
                                ["paddingTop", "paddingBottom"],
                                15
                              );
                            }
                          );
                        }}
                      >
                        <span style={{ pointerEvents: "none" }}>L</span>
                      </li>
                    </ul>
                  </div>
                )}
              </li>
            </>
          )}
          {element.type == "text" && availableSettings?.text?.fontFamily && (
            <>
              {!(['xs', 'sm'].includes(this.props.currentDevice)) && (
                <li>
                  <Select
                    value={(textSettings && textSettings.fontWeight) || ""}
                    onChange={(value) => {
                      this._changedSettingsTwo("text", "fontWeight", value);
                    }}
                    placeholder={l("Font weight")}
                    options={this._fontsWeightOptions(
                      (textSettings && textSettings.fontFamilyId) || "",
                      (textSettings && textSettings.fontFamily) || ""
                    )}
                    dark
                  />
                </li>
              )}
              <li className="prelative">
                <li
                  className={`quickbar ${this.state.popup === "textDecor" ? "selected" : ""
                    }`}
                  onClick={() => {
                    if (this.state.popup !== "textDecor")
                      this.setState({
                        popup: "textDecor",
                      });
                    else this.setState({ popup: null });
                  }}
                >
                  <Icons icon="bold" />
                </li>

                {this.state.popup == "textDecor" && (
                  <div className="section quickbartools">
                    <ul className="inline-options dark grow">
                      <li
                        onClick={() => {
                          if (textSettings?.fontWeight != 600)
                            this._changedSettingsTwo("text", "fontWeight", 600);
                          else
                            this._changedSettingsTwo("text", "fontWeight", 200);
                        }}
                        className={`${textSettings?.fontWeight === 600 ? "selected" : ""
                          }`}
                      >
                        <Icons icon="bold" />
                      </li>
                      <li
                        onClick={() => {
                          textSettings?.fontStyle === "italic"
                            ? this._changedSettingsTwo(
                              "text",
                              "fontStyle",
                              "normal"
                            )
                            : this._changedSettingsTwo(
                              "text",
                              "fontStyle",
                              "italic"
                            );
                        }}
                        className={`${textSettings?.fontStyle === "italic" ? "selected" : ""
                          }`}
                      >
                        <Icons icon="italic" />
                      </li>
                      <li
                        onClick={() => {
                          textSettings?.textDecorationLine === "underline"
                            ? this._changedSettingsTwo(
                              "text",
                              "textDecorationLine",
                              "none"
                            )
                            : this._changedSettingsTwo(
                              "text",
                              "textDecorationLine",
                              "underline"
                            );
                        }}
                        className={`${textSettings?.textDecorationLine === "underline"
                          ? "selected"
                          : ""
                          }`}
                      >
                        <Icons icon="underline" />
                      </li>
                    </ul>
                  </div>
                )}
              </li>
            </>
          )}

          {element.type !== "list" && availableSettings?.text?.textAlign && (
            <>
              <li className="prelative">
                <li
                  className={`quickbar ${this.state.textAlign ? "selected" : ""
                    }`}
                  onClick={() => {
                    this.setState({
                      textAlign: !this.state.textAlign,
                      popup: "textAlign",
                    });
                  }}
                >
                  <FontAwesomeIcon icon={["fa", "align-left"]} />
                </li>

                {this.state.textAlign && this.state.popup == "textAlign" && (
                  <div className="section quickbartools">
                    <ul className="inline-options dark grow">
                      <li
                        className={
                          textSettings && textSettings.textAlign === "left"
                            ? "selected"
                            : ""
                        }
                        onClick={() => {
                          this._changedSettingsTwo("text", "textAlign", "left");
                        }}
                      >
                        <FontAwesomeIcon icon={["fa", "align-left"]} />
                      </li>
                      <li
                        className={
                          textSettings && textSettings.textAlign === "center"
                            ? "selected"
                            : ""
                        }
                        onClick={() => {
                          this._changedSettingsTwo(
                            "text",
                            "textAlign",
                            "center"
                          );
                        }}
                      >
                        <FontAwesomeIcon icon={["fa", "align-center"]} />
                      </li>
                      <li
                        className={
                          textSettings && textSettings.textAlign === "right"
                            ? "selected"
                            : ""
                        }
                        onClick={() => {
                          this._changedSettingsTwo(
                            "text",
                            "textAlign",
                            "right"
                          );
                        }}
                      >
                        <FontAwesomeIcon icon={["fa", "align-right"]} />
                      </li>
                      <li
                        className={
                          textSettings && textSettings.textAlign === "justify"
                            ? "selected"
                            : ""
                        }
                        onClick={() => {
                          this._changedSettingsTwo(
                            "text",
                            "textAlign",
                            "justify"
                          );
                        }}
                      >
                        <FontAwesomeIcon icon={["fa", "align-justify"]} />
                      </li>
                    </ul>
                  </div>
                )}
              </li>
            </>
          )}
          {availableSettings?.alignment && (
            <li className="prelative">
              <li
                className={`quickbar ${this.state.popup === "alignment" ? "selected" : ""
                  }`}
                onClick={() => {
                  if (this.state.popup !== "alignment")
                    this.setState({
                      popup: "alignment",
                    });
                  else this.setState({ popup: null });
                }}
              >
                <FontAwesomeIcon icon={["fa", "align-left"]} />
              </li>
              {this.state.popup === "alignment" && (
                <div className="section quickbartools">
                  <ul className="inline-options dark grow">
                    <li
                      onClick={() => {
                        this._changedSettingsOne("alignment", "left");
                      }}
                      className={
                        !alignment || (alignment && alignment === "left")
                          ? "selected"
                          : ""
                      }
                    >
                      <span>{l("Left")}</span>
                    </li>
                    <li
                      onClick={() => {
                        this._changedSettingsOne("alignment", "center");
                      }}
                      className={
                        alignment && alignment === "center" ? "selected" : ""
                      }
                    >
                      <span>{l("Center")}</span>
                    </li>
                    <li
                      onClick={() => {
                        this._changedSettingsOne("alignment", "right");
                      }}
                      className={
                        alignment && alignment === "right" ? "selected" : ""
                      }
                    >
                      <span>{l("Right")}</span>
                    </li>
                  </ul>
                </div>
              )}
            </li>
          )}

          {/* Color block all color will go here */}

          {availableSettings?.text?.color && (
            <>
              <li className="quickbar-box">
                <ColorSetter
                  color={(textSettings && textSettings.color) || ""}
                  onChangeComplete={(color) => {
                    this._changedSettingsTwo("text", "color", color);
                  }}
                  quickbar
                  tooltipTitle={"Text Color"}
                  onClick={() => {
                    this.setState({ popup: "color" });
                  }}
                  show={this.state.popup == "color" ? true : false}
                />
              </li>
            </>
          )}
          {element?.name == "Button" && availableSettings?.background && (
            <li className="quickbar-box">
              <ColorSetter
                color={
                  (backgroundSettings && backgroundSettings.backgroundColor) ||
                  ""
                }
                onChangeComplete={(color) => {
                  this._changedSettingsTwo(
                    "background",
                    "backgroundColor",
                    color
                  );
                }}
                quickbar
                tooltipTitle={"Background Color"}
              />
            </li>
          )}
          {availableSettings.productStockCountdownColors && (
            <>
              <li className="quickbar-box">
                <ColorSetter
                  color={counterColor || ""}
                  onChangeComplete={(color) => {
                    this._changedDatasOne("counterColor", color);
                  }}
                  quickbar
                  tooltipTitle={"Counter Color"}
                  onClick={() => {
                    this.setState({ popup: "color" });
                  }}
                  show={this.state.popup == "color" ? true : false}
                />
              </li>

              <li className="quickbar-box">
                <ColorSetter
                  color={activeColor || ""}
                  onChangeComplete={(color) => {
                    this._changedDatasOne("activeColor", color);
                  }}
                  quickbar
                  tooltipTitle={"Active bar color"}
                  onClick={() => {
                    this.setState({ popup: "color" });
                  }}
                  show={this.state.popup == "color" ? true : false}
                />
              </li>
              <li className="quickbar-box">
                <ColorSetter
                  color={barColor || ""}
                  onChangeComplete={(color) => {
                    this._changedDatasOne("barColor", color);
                  }}
                  quickbar
                  tooltipTitle={"Danger bar color"}
                  onClick={() => {
                    this.setState({ popup: "color" });
                  }}
                  show={this.state.popup == "color" ? true : false}
                />
              </li>
            </>
          )}
          {availableSettings.productCountDownTimerSettings && (
            <>
              <li className="quickbar-box">
                <ColorSetter
                  color={timerColor || ""}
                  onChangeComplete={(color) => {
                    this._changedSettingsOne("timerColor", color);
                  }}
                  quickbar
                  tooltipTitle={"Text Color"}
                  onClick={() => {
                    this.setState({ popup: "color" });
                  }}
                  show={this.state.popup == "color" ? true : false}
                />
              </li>
              <li className="quickbar-box">
                <ColorSetter
                  color={timerBgColor || ""}
                  onChangeComplete={(color) => {
                    this._changedSettingsOne("timerBgColor", color);
                  }}
                  quickbar
                  tooltipTitle={"Background color"}
                  onClick={() => {
                    this.setState({ popup: "color" });
                  }}
                  show={this.state.popup == "color" ? true : false}
                />
              </li>
            </>
          )}

          {availableSettings.productViewersSettings && (
            <>
              <li className="quickbar-box">
                <ColorSetter
                  color={viewersTextColor || ""}
                  onChangeComplete={(color) => {
                    this._changedDatasOne("viewersTextColor", color);
                  }}
                  quickbar
                  tooltipTitle={"viewers text color"}
                  onClick={() => {
                    this.setState({ popup: "color" });
                  }}
                  show={this.state.popup == "color" ? true : false}
                />
              </li>
              <li className="quickbar-box">
                <ColorSetter
                  color={viewersBgColor || ""}
                  onChangeComplete={(color) => {
                    this._changedDatasOne("viewersBgColor", color);
                  }}
                  quickbar
                  tooltipTitle={"viewers background color"}
                  onClick={() => {
                    this.setState({ popup: "color" });
                  }}
                  show={this.state.popup == "color" ? true : false}
                />
              </li>
            </>
          )}
          {/* color settigns end */}

          {/* {element.type == "slider" && (
            <li>
              <button
                onClick={() => {
                  newDraggableElement(
                    this.state.datas.slider,
                    "slider",
                    "Slide",
                    (elements) => {
                      this._changedDatasOne("slider", elements);
                    }
                  );
                }}
              >
                <Icons icon="plus" />
              </button>
            </li>
          )} */}

          {/* ICON TO SHOW BLOCK SETTING COMPONENT */}
        </>
      );
    } else {
      setShowBlockSettings(true);

      return <></>;
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WisywigCommandCenter);
